import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, Grid } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useStore, useToast, useResource, useModal, usePage, useGrid } from "@/comn/hooks";
import {
    URLS,
    APIS,
    SF_CSTM_OFCR_INFO_FORM,
    SG_USR_CSTM_LIST,
} from "@/tra/tancis/ptli/usr/cstmofcr/services/PtliCstmOfcrService";
import { v1 } from "uuid";
import { log } from "console";

/*
 * Customs officer management registration
 * !== 세관직원관리 수정 ==!
 */
export const PTLI0902003S = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const { usrDmnId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const [frstTin, setFrstTin] = useState();
    const [passTin, setPassTin] = useState();
    const [chgTin, setChgTin] = useState();
    const [saveBtn, setSaveBtn] = useState(false);
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "PTL0001" },
            { area: "comnCd", comnCd: "PTL0003" },
            { area: "cstmCd" },
            { area: "orgzSub" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Customs officer management Form !== 세관직원관리 Form ==!
        cstmOfcrForm: useForm({
            defaultSchema: SF_CSTM_OFCR_INFO_FORM,
            defaultValues: { ...(pgeStore?.form || {}) },
        }),
    };

    /*
     * Declaration Grid
     * !== Grid 정의 ==!
     */
    const grid = { usrCstmList: useGrid({ defaultSchema: SG_USR_CSTM_LIST }) };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getCstmOfcr: useFetch({
            api: (usrDmnId) => APIS.getCstmOfcr(usrDmnId),
            enabled: false,
            onSuccess: (data) => {
                const content = data.cstmOfcrInfo.content;
                if (!comnUtils.isEmpty(content)) {
                    form.cstmOfcrForm.setValues({
                        ...content,
                        fileGrpUuid: content.usrDmnId,
                        // fileAtchGrpUuid: content.usrDmnId,
                        fileAtchGrpUuid: `${content.usrDmnId}-attach`,
                    });
                    form.cstmOfcrForm.setValue("preRoleId", content.roleId);
                    //console.log(form.cstmOfcrForm.getValue("preRoleId"));
                    handler.getCstmList("Y");
                    handler.getUnitList("Y");
                    setFrstTin(form.cstmOfcrForm.getValue("usrTin"));

                    if (!comnUtils.isEmpty(content.aprvId) && content.aprvYn == "N") {
                        // 결재 승인이 안된 내부사용자 저장버튼 숨김
                        setSaveBtn(true);
                    }
                }
            },
        }),
        getUsrCstmList: useFetch({
            api: (usrDmnId) => APIS.getUsrCstmList(usrDmnId),
            onSuccess: () => {},
            onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
        // Update Customs officer !== 세관직원 수정 ==!
        updateCstmOfcr: useFetch({
            api: (data) => APIS.updateCstmOfcr({ ...data }),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => navigate(`${URLS.ptli0902004q}/${usrDmnId}`),
                    close: false,
                });
            },
            onError: (error) => {
                const errorData = error.response.data;

                if (error.response.status === 400) {
                    form.cstmOfcrForm.setErrors(errorData.errors);
                    modal.openModal({ content: "msg.00006" }); // An error occurred during processing.
                    return;
                }

                const { errorCode, errorMessage } = errorData;

                // BizException
                if (errorCode === "-999") {
                    modal.openModal({ content: errorMessage });
                } else {
                    toast.showToast({ type: "error", content: "msg.com.00018" }); // An error occurred. !== 에러가 발생했습니다! ==!
                }
            },
        }),
        getCstmList: useFetch({
            api: (objParam) => APIS.getOrgzList(objParam),
            enabled: false,
            onSuccess: (data) => {
                if (data?.orgzList?.content.length > 0) {
                    form.cstmOfcrForm.setSchema("cstmOfceCd", {
                        options: data.orgzList.content.map((item: any) => ({
                            label: item.cstmOrgzNm,
                            value: item.cstmOrgzCd,
                        })),
                    });
                }

                handler.getCstmRoleList();
            },
            onError: () => {},
            showToast: true,
        }),

        // unit search by section !== 섹션별 유닛 조회 ==!
        getUnitList: useFetch({
            api: (objParam) => APIS.getOrgzList(objParam),
            enabled: false,
            onSuccess: (data) => {
                if (data.orgzList.content.length > 0) {
                    form.cstmOfcrForm.setSchema("cstmUnitOrgzCd", {
                        options: data.orgzList.content.map((item: any) => ({
                            label: item.cstmOrgzNm,
                            value: item.cstmOrgzCd,
                        })),
                    });
                }

                handler.getCstmRoleList();
            },
            onError: () => {},
            showToast: true,
        }),
        // Section search by customs role !== 조직 역할 목록 조회 ==!
        getCstmRoleList: useFetch({
            api: (objParam) => APIS.getCstmRoleList(objParam),
            enabled: false,
            onSuccess: (data) => {
                if (data?.cstmRoleList?.content.length > 0) {
                    form.cstmOfcrForm.setSchema("roleId", {
                        options: data.cstmRoleList.content.map((item: any) => ({
                            label: item.roleNm,
                            value: item.roleId,
                        })),
                    });
                } else {
                    form.cstmOfcrForm.setSchema("roleId", { options: [] });

                    form.cstmOfcrForm.setValue("roleId", "");
                }
            },
            onError: () => {},
            showToast: true,
        }),

        // Check TIN validity !== TIN 유효성을 체크 후 사용자 정보를 저장한다. ==!
        getUsrTinInfo: useFetch({
            api: () => APIS.getTinNoLst(form.cstmOfcrForm.getValue("usrTin"), "N"),
            onSuccess: (data) => {
                const tinNoList = data.tinNoList.content;

                if (tinNoList.length == 1) {
                    form.cstmOfcrForm.clearErrors("usrTin");
                    setPassTin(form.cstmOfcrForm.getValue("usrTin"));
                } else {
                    form.cstmOfcrForm.setError("usrTin", { message: "msg.clr.00004", type: "error" }); // The TIN does not exist. Please recheck the TIN.
                }
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        onGridDelBtnClick: () => {
            const list = grid.usrCstmList.getChecked();
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" }); // No data has been selected. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            modal.openModal({
                content: "msg.com.00049",
                onConfirm: () => {
                    grid.usrCstmList.deleteRow("checkbox");
                },
            });
        },
        onGridAddBtnClick: () => {
            grid.usrCstmList.addRow({ usrDmnId, useYn: "Y" });
            handler.chkDuplCstmOfceCd();
        },
        onSaveBtnClick: () => {
            if (frstTin != chgTin && passTin != chgTin) {
                toast.showToast({ type: "warning", content: "msg.clr.00004" }); // The TIN does not exist. Please recheck the TIN.
                return;
            }

            if (!comnUtils.isEmpty(form.cstmOfcrForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            // check of duplicate customs office
            const currCstmOfceCd = form.cstmOfcrForm.getValues("cstmOfceCd");
            const usrCstmList = grid.usrCstmList.getData();

            if (
                usrCstmList.some(
                    (item: any) => comnUtils.isEmptyString(item.cstmCd) || comnUtils.isUndefined(item.cstmCd),
                )
            ) {
                toast.showToast({
                    type: "warning",
                    content: t("msg.com.00035", { 0: t("T_USR_CSTM_LIST") + " : " + t("L_CSTM_OFCE") }),
                });
                return;
            } // Please enter {0}. !== {0} 을(를) 입력하여 주세요. ==!

            if (usrCstmList.some((item: any) => item.cstmCd == currCstmOfceCd)) {
                toast.showToast({
                    type: "warning",
                    content: t("msg.cgm.00231", { 0: t("L_CSTM_OFCE") }),
                });
                return;
            } // {0} is already registered. !== {0}가 이미 등록되었습니다. ==!

            if (
                usrCstmList.some((item: any, index: any, self: any) => {
                    return index !== self.findIndex((v: any) => v.cstmCd === item.cstmCd);
                })
            ) {
                toast.showToast({
                    type: "warning",
                    content: t("msg.cgm.00383", { 0: t("T_USR_CSTM_LIST") }),
                });
                return;
            } // Duplicate data exists. ( {0} ) !== 중복된 데이터가 존재합니다. ( {0} ) ==!

            form.cstmOfcrForm.handleSubmit(
                () => {
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            const data = form.cstmOfcrForm.getValues();
                            if (typeof data.fileGrpUuid === "object") {
                                data.fileSaveDto = data.fileGrpUuid;
                                data.fileGrpUuid = null;
                            }
                            // Handle attachment file group UUID ? !== 첨부 파일 그룹 UUID 처리 ?==!
                            if (typeof data.fileAtchGrpUuid === "object") {
                                data.atchFileSaveDto = data.fileAtchGrpUuid;
                                data.fileAtchGrpUuid = null;
                            }

                            fetch.updateCstmOfcr.fetch({
                                ...data,
                                usrCstmList: grid.usrCstmList.getData({ excludes: ["origin"] }),
                            });
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },

        // Section search by customs !== 섹션별 세관 조회 ==!
        getCstmList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.cstmOfcrForm.setSchema("cstmOfceCd", { options: [] });
                form.cstmOfcrForm.setSchema("cstmUnitOrgzCd", { options: [] });
                form.cstmOfcrForm.setValue("cstmOfceCd", "");
                form.cstmOfcrForm.setValue("cstmUnitOrgzCd", "");
            }

            form.cstmOfcrForm.setValue("cstmOrgzTpCd", "C");

            const objParam = {
                cstmOrgzTpCd: form.cstmOfcrForm.getValue("cstmOrgzTpCd"),
                cstmSctnOrgzCd: form.cstmOfcrForm.getValue("cstmSctnOrgzCd"),
                cstmOfceCd: form.cstmOfcrForm.getValue("cstmOfceCd"),
            };

            fetch.getCstmList.fetch(objParam);
        },

        // unit search by section !== 세관별 유닛 조회 ==!
        getUnitList: (loadYn: any) => {
            if (loadYn !== "Y") {
                form.cstmOfcrForm.setSchema("cstmUnitOrgzCd", { options: [] });
                form.cstmOfcrForm.setValue("cstmUnitOrgzCd", "");
            }

            form.cstmOfcrForm.setValue("cstmOrgzTpCd", "U");

            const objParam = {
                cstmOrgzTpCd: form.cstmOfcrForm.getValue("cstmOrgzTpCd"),
                cstmSctnOrgzCd: form.cstmOfcrForm.getValue("cstmSctnOrgzCd"),
                cstmOfceCd: form.cstmOfcrForm.getValue("cstmOfceCd"),
            };

            fetch.getUnitList.fetch(objParam);
        },

        // Section search by customs role !== 세관 역할 조회 ==!
        getCstmRoleList: () => {
            const cstmSctnOrgzCd = form.cstmOfcrForm.getValue("cstmSctnOrgzCd");

            // Initialize role combo if there is no section code !== 섹션 코드 없는 경우 역할 콤보 초기화 ==!
            if (comnUtils.isEmpty(cstmSctnOrgzCd)) {
                form.cstmOfcrForm.setSchema("roleId", { options: [] });
                form.cstmOfcrForm.setValue("roleId", "");
                return;
            }

            const cstmOfceCd = form.cstmOfcrForm.getValue("cstmOfceCd");
            const cstmUnitOrgzCd = form.cstmOfcrForm.getValue("cstmUnitOrgzCd");
            const cstmOrgzTpCd = comnUtils.isEmpty(cstmOfceCd) ? "S" : !comnUtils.isEmpty(cstmUnitOrgzCd) ? "U" : "C";
            const objParam = { cstmSctnOrgzCd, cstmOfceCd, cstmUnitOrgzCd, cstmOrgzTpCd };
            fetch.getCstmRoleList.fetch(objParam);
        },

        onUsrStatChange: (value: any) => form.cstmOfcrForm.setSchema("mdfyRsn", { required: value == 2 }),

        // Check TIN validity !== TIN 유효성을 체크한다. ==!
        getUsrTinInfo: () => {
            const usrTin = form.cstmOfcrForm.getValue("usrTin");
            if (usrTin) fetch.getUsrTinInfo.fetch(usrTin);
        },
        // check of duplicate customs office
        chkDuplCstmOfceCd: () => {
            const currCstmOfceCd = form.cstmOfcrForm.getValues("cstmOfceCd");
            const usrCstmList = grid.usrCstmList.getData();

            if (usrCstmList.some((item: any) => item.cstmCd == currCstmOfceCd)) {
                toast.showToast({
                    type: "warning",
                    content: t("msg.cgm.00231", { 0: t("L_CSTM_OFCE") }),
                });
                return;
            } // {0} is already registered. !== {0}가 이미 등록되었습니다. ==!

            if (
                usrCstmList.some((item: any, index: any, self: any) => {
                    return (
                        !comnUtils.isUndefined(item.cstmCd) &&
                        index !==
                            self.findIndex((v: any) => !comnUtils.isUndefined(v.cstmCd) && v.cstmCd === item.cstmCd)
                    );
                })
            ) {
                toast.showToast({
                    type: "warning",
                    content: t("msg.cgm.00383", { 0: t("T_USR_CSTM_LIST") }),
                });
                return;
            } // Duplicate data exists. ( {0} ) !== 중복된 데이터가 존재합니다. ( {0} ) ==!
        },
    };

    useEffect(() => {
        form.cstmOfcrForm.setSchema("cstmOfcrNo", { pattern: "" });

        grid.usrCstmList.setOption("checkbox", true);
        grid.usrCstmList.setOption("index", false);

        grid.usrCstmList.setEdit("cell", "cstmCd", true);
        grid.usrCstmList.setEdit("cell", "useYn", true);

        fetch.getCstmOfcr.fetch(usrDmnId);
        fetch.getUsrCstmList.fetch(usrDmnId);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Title title={"T_CSTM_OFCR"} titleSize={2} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.cstmOfcrNo} readOnly={true} />
                            <Group.Control
                                {...form.cstmOfcrForm.schema.usrTin}
                                rightButton={{
                                    icon: "search",
                                    onClick: () => {
                                        const usrNo = form.cstmOfcrForm.getValue("usrTin");
                                        if (usrNo?.length == 9) {
                                            form.cstmOfcrForm.clearErrors("usrTin");
                                            handler.getUsrTinInfo();
                                        } else {
                                            form.cstmOfcrForm.setError("usrTin", {
                                                message: "msg.esw.00070",
                                                type: "error",
                                            }); // TIN must be 9 digits. !== TIN은 9자리여야 합니다. ==!
                                        }
                                    },
                                }}
                                onChange={() => {
                                    setChgTin(form.cstmOfcrForm.getValue("usrTin"));
                                    form.cstmOfcrForm.setError("usrTin", { message: "msg.clr.00004", type: "error" }); // Please check your TIN. !== TIN을 조회해주세요. ==!
                                }}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.usrDmnId} readOnly={true} />
                            <Group.Control {...form.cstmOfcrForm.schema.usrNm} readOnly={true} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.usrTelno} />
                            <Group.Control {...form.cstmOfcrForm.schema.usrEmlAddr} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.actnUsrYn} required={true} />
                            <Group.Control
                                {...form.cstmOfcrForm.schema.usrStatCd}
                                onChange={handler.onUsrStatChange}
                                required={true}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.fileGrpUuid} copy={false} />
                            <Group.Control {...form.cstmOfcrForm.schema.fileAtchGrpUuid} copy={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.mdfyRsn} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Title title={"T_AFFIL"} titleSize={2} />
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.cstmSctnOrgzCdNm} edit={false} />
                            <Group.Control {...form.cstmOfcrForm.schema.cstmOfceCdNm} edit={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.cstmUnitOrgzCdNm} edit={false} />
                            <Group.Control {...form.cstmOfcrForm.schema.roleNm} edit={false} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Title title={"T_CHG_AFFIL"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.cstmOfcrForm.schema.cstmSctnOrgzCd}
                                popupParams={{ cstmOrgzTpCd: "S" }}
                                onChange={() => handler.getCstmList("N")}
                            ></Group.Control>
                            <Group.Control {...form.cstmOfcrForm.schema.roleId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.cstmOfcrForm.schema.cstmOfceCd}
                                onChange={() => handler.getUnitList("N")}
                            ></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.cstmOfcrForm.schema.cstmUnitOrgzCd}
                                onChange={handler.getCstmRoleList}
                            ></Group.Control>
                        </Group.Row>
                    </Group.Section>

                    <Group.Title title={"T_SMS_EML_RCPN_YN"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.cstmOfcrForm.schema.smsRcpnYn} required={true} />
                            <Group.Control {...form.cstmOfcrForm.schema.emlRcpnYn} required={true} />
                        </Group.Row>
                    </Group.Section>

                    <Group.Section gap={2}>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_USR_CSTM_LIST"} titleSize={2} />
                            </Layout.Left>
                            <Layout.Right>
                                <Layout.Button role={"gridAdd"} onClick={handler.onGridAddBtnClick} />
                                <Layout.Button role={"gridDelete"} onClick={handler.onGridDelBtnClick} />
                            </Layout.Right>
                        </Layout>
                        <Grid {...grid.usrCstmList.grid} data={fetch.getUsrCstmList.data?.usrCstmList} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button variant="secondary" onClick={() => navigate(`${URLS.ptli0902004q}/${usrDmnId}`)}>
                        {t("B_PRE")}
                    </Button>
                    <Button role="list" onClick={() => navigate(URLS.ptli0902001q)} />
                </Layout.Left>
                <Layout.Right>
                    <Button role="save" onClick={handler.onSaveBtnClick} hidden={saveBtn} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
